import React from 'react';
import { Link, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import './styles/Home.css';
import Topbar from './Topbar';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from '../Assets/logo.svg.png'
import { Stack } from '@mui/material';
import images from '../Assets/images.jpeg'

const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = (path) => location.pathname.includes(path);
    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
        window.location.reload();
    }
    return (
        <React.Fragment>
            {/* <Topbar /> */}
            <aside className='asideNavbar' >
                <div className='asideNavbarDiv'>
                    {/* <Link id='link' to='/' >
                        <h1>FNB Connect</h1></Link> */}
                    <Link id='link' to='/' >
                        <Stack sx={{alignItems:'center',marginBottom:'20px',marginTop:'20px'}}>
                            <img src={images} alt='LOGO' width={'130px'} />
                        </Stack>
                    </Link>

                    <Link to="/Dashboard" id='link'>
                        <div
                            className={`menu ${isActive("/Dashboard") ? "activeRoute" : ""
                                }`}
                        >
                            Dashboard
                        </div>
                    </Link>
                    <Link to="/UsersList" id='link'>
                        <div
                            className={`menu ${isActive("/UsersList") ? "activeRoute" : ""
                                }`}
                        >
                            Users List
                        </div>
                    </Link>
                    <Link to="/NewArrivels" id='link'>
                        <div
                            className={`menu ${isActive("/NewArrivels") ? "activeRoute" : ""
                                }`}
                        >
                            New Arrivals
                        </div>
                    </Link>
                    <Link to="/Messages" id='link'>
                        <div
                            className={`menu ${isActive("/Messages") ? "activeRoute" : ""
                                }`}
                        >
                            Messages
                        </div>
                    </Link>
                    

                    <div className={`logout`} onClick={handleLogout}>
                        <LogoutIcon />Logout
                    </div>
                </div>
            </aside>
            <div className='outline_style' style={{ position: 'absolute', top: '100px', left: '18%', width: '78%' }}>
                <Outlet /></div>
        </React.Fragment>
    )
}

export default Home
